<template>
  <div class="index py-5">
    <span class="d-flex flex-row page-title">{{$t("intranet.title.page.ambassador.list")}}</span>
    <div class="searchable-list-container">
      <AveineAmbassadorList :APIbaseURL="APIbaseURL" :adminMode="true" />
    </div>
  </div>
</template>

<script>
import { AveineAmbassadorList } from 'aveine-ambassador'
export default {
  name: 'Index',
  data() {
    return {
      APIbaseURL: process.env.VUE_APP_API_HOST
    }
  },
  components: {
    AveineAmbassadorList
  }
}
</script>
